<template>
  <v-expansion-panels
      v-if="doc.altTexts && doc.altTexts.length != 0"
      multiple
      flat
      v-model="altTextsModel"
  >
    <v-expansion-panel
        v-for="(altText, index) in doc.altTexts"
        :key="altText.name"
        @change="setAltTextExpansion({
          name: altText.name,
          value: !altTextsModel.includes(index),
        })"
    >
      <v-expansion-panel-header color="grey lighten-4">
        <div>
          <v-chip :color="getColor(altText)">{{ altText.name }}</v-chip>
        </div>
        <div
            v-if="!altTextsModel.includes(index)"
            class="d-inline-block text-truncate"
            :class="{
              rtl: isRightToLeftText(altText.text),
              [`font-${projectLanguage}`]: true,
            }"
            :style="`white-space: pre-wrap; letter-spacing: 0.0em !important; line-height: 1.75rem; max-width: 85%;`"
        >
          {{ altText.text }}
        </div>
        <div></div>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="pa-2" color="grey lighten-4">
        <div
            v-if="altTextsModel.includes(index)"
            :class="{
              rtl: isRightToLeftText(altText.text),
              [`font-${projectLanguage}`]: true,
            }"
            :style="`white-space: pre-wrap; letter-spacing: 0.0em !important; line-height: 1.75rem; max-width: 95%;`"
        >
          {{ altText.text }}
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import languageMixin from "../../mixins/languageMixin";
import {mapState, mapGetters, mapMutations} from "vuex";

export default {
  props: ["doc"],
  mixins: [languageMixin],
  data() {
    return {
      altTextsModel: [],
    };
  },
  mounted() {
    if (this.doc.altTexts) {
      for (let i = 0; i < this.doc.altTexts.length; i++) {
        const altText = this.doc.altTexts[i];
        if (this.altTextsExpansion[altText.name]) {
          this.altTextsModel.push(i);
        }
      }
    }
  },
  computed: {
    ...mapState(["altTextsExpansion"]),
    ...mapGetters(["projectLanguage"]),
    ...mapState("settings", ["labelsByName"]),
  },
  methods: {
    ...mapMutations(["setAltTextExpansion"]),
    isRightToLeftText(text) {
      return this.containsCharactersFromRightToLeftLanguage(text);
    },
    getColor(altText) {
      const label = this.labelsByName[altText?.name];
      if (label && label.color) {
        return label.color;
      } else {
        return "grey";
      }
    },
  }
};
</script>